import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators'
import { Subject } from 'rxjs';

import { ValuesExchangeProvider } from '@nrwl/common-lib';

@Component({
  selector: 'nrwl-user-profile',
  templateUrl: './user.profile.component.html',
  styleUrls: ['./user.profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  showAlertsPreference: boolean;
  showThemePreference: boolean;
  isLoading = true;
  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(
    private readonly exchange: ValuesExchangeProvider,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.activeRoute.queryParams
      .pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
        this.showAlertsPreference = params.showAlertsPreference === 'true' ? true : false;
        this.showThemePreference = params.showThemePreference === 'true' ? true : false;
      })
    this.exchange.registerInterest('user-profile-loading', isLoading => {
      this.isLoading = isLoading;
    });
  }
  ngOnDestroy() {  //eslint-disable-line
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}